import { Col, Flex, Row } from 'antd';
import { ErrorBox } from '~/app/components/common/Error/ErrorBox';
import { Loader } from '~/app/components/common/Loader/Loader';
import { DropOffCausesCard } from './components/DropOffCausesCard/DropOffCausesCard';
import { LocationsTableCard } from './components/LocationsTableCard/LocationsTableCard';
import { MetricProgressCard } from './components/MetricProgressCard/MetricProgressCard';
import { ServiceQualityPageHeader } from './components/ServiceQualityPageHeader/ServiceQualityPageHeader';
import { SiteSegmentCard } from './components/SiteSegmentCard/SiteSegmentCard';
import type { ServiceQualityPageViewProps } from './ServiceQualityPage.types';

export function ServiceQualityPageView(props: ServiceQualityPageViewProps) {
  const {
    isLoading,
    isError,
    errorTitle,
    errorMessage,
    pageTitle,
    subtitle,
    period,
    periodOptions,
    periodAriaLabel,
    generateReportLabel,
    chargingKpisLoading,
    chargingKpisError,
    sessionSuccess,
    weightedUptime,
    customerRating,
    dropOffCauses,
    ownedSegment,
    managedSegment,
    locationsTitle,
    locationsUrgentNote,
    locationsColumns,
    locationsRows,
    escalationNote,
    onPeriodChange,
    onGenerateReport,
  } = props;

  if (isLoading && !customerRating) {
    return <Loader />;
  }

  if (isError) {
    return <ErrorBox title={errorTitle} description={errorMessage} />;
  }

  if (!customerRating || !ownedSegment || !managedSegment) {
    return <Loader />;
  }

  return (
    <div className="app-page om-dashboard">
      <Flex vertical gap={24}>
        <ServiceQualityPageHeader
          title={pageTitle}
          subtitle={subtitle}
          period={period}
          periodOptions={periodOptions}
          periodAriaLabel={periodAriaLabel}
          generateReportLabel={generateReportLabel}
          onPeriodChange={onPeriodChange}
          onGenerateReport={onGenerateReport}
        />

        <Row gutter={[16, 16]} align="stretch">
          {chargingKpisError ? (
            <Col span={24}>
              <ErrorBox title={errorTitle} description={chargingKpisError} />
            </Col>
          ) : null}
          {chargingKpisLoading && !sessionSuccess ? (
            <Col span={24}>
              <Loader />
            </Col>
          ) : null}
          {sessionSuccess ? (
            <Col xs={24} lg={8} style={{ display: 'flex' }}>
              <div style={{ width: '100%' }}>
                <MetricProgressCard {...sessionSuccess} />
              </div>
            </Col>
          ) : null}
          {weightedUptime ? (
            <Col xs={24} lg={8} style={{ display: 'flex' }}>
              <div style={{ width: '100%' }}>
                <MetricProgressCard {...weightedUptime} />
              </div>
            </Col>
          ) : null}
          {dropOffCauses ? (
            <Col xs={24} lg={8} style={{ display: 'flex' }}>
              <div style={{ width: '100%' }}>
                <DropOffCausesCard card={dropOffCauses} />
              </div>
            </Col>
          ) : null}
        </Row>

        <Row gutter={[16, 16]}>
          <Col xs={24} lg={8}>
            <MetricProgressCard {...customerRating} />
          </Col>
        </Row>

        <Row gutter={[16, 16]} align="stretch">
          <Col xs={24} lg={12} style={{ display: 'flex' }}>
            <div style={{ width: '100%' }}>
              <SiteSegmentCard segment={ownedSegment} />
            </div>
          </Col>
          <Col xs={24} lg={12} style={{ display: 'flex' }}>
            <div style={{ width: '100%' }}>
              <SiteSegmentCard segment={managedSegment} />
            </div>
          </Col>
        </Row>

        <LocationsTableCard
          title={locationsTitle}
          urgentNote={locationsUrgentNote}
          columns={locationsColumns}
          rows={locationsRows}
          escalationNote={escalationNote}
        />
      </Flex>
    </div>
  );
}
